import { render, staticRenderFns } from "./advertiser-selector.vue?vue&type=template&id=2c71371e"
import script from "./advertiser-selector.vue?vue&type=script&lang=js"
export * from "./advertiser-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports